/**
 * navigation.ts — view-router inversion point (ADR-002 phase C).
 *
 * Features must not import the composition root (auth.ts) to navigate or to
 * open the registration prompt — those imports closed the hub cycles
 * feature → auth → feature. Instead the composition root registers its
 * implementations here, and features call the delegates below.
 */

export type SwitchViewFn = (name: string) => void | Promise<void>;

let switchViewImpl: SwitchViewFn = () => {
  console.warn('navigation: view router is not registered yet');
};

let registrationPromptImpl: () => void = () => {
  console.warn('navigation: registration prompt is not registered yet');
};

/** Called by the composition root (auth.ts) at startup. */
export function registerViewRouter(fn: SwitchViewFn): void {
  switchViewImpl = fn;
}

/** Called by the composition root (auth.ts) at startup. */
export function registerRegistrationPrompt(fn: () => void): void {
  registrationPromptImpl = fn;
}

export function switchView(name: string): void | Promise<void> {
  return switchViewImpl(name);
}

/**
 * Стартовый раздел — первый видимый пункт бокового меню, а не зашитый в код
 * «Разговор»: порядок кнопок в #nav-main и определяет, что открывается при
 * входе. Админ-панель пропускается — это служебный раздел, стартовать с него
 * не должен даже админ.
 */
export function firstMenuView(): string {
  const buttons = document.querySelectorAll<HTMLElement>('#nav-main .nav-btn:not(.hidden)');
  for (const btn of buttons) {
    const view = btn.dataset.view;
    if (view && view !== 'admin') return view;
  }
  return 'conversation';
}

export function showRegistrationPrompt(): void {
  registrationPromptImpl();
}
